module.exports = __webpack_public_path__ + "img/527.2489b1e4.gif";